/** User API — Faz 1.4 createApi factory. (user + account resource karması) */
import {createApi} from './_factory'
import type {CommonNs, UIPreferencesNs, UserNs} from '@shared/types'

const user = createApi('user')
const account = createApi('account')

export const UserApi = {
  userMe: () =>
    user.get<UserNs.UserInfo>('me'),
  setSelectedTheme: (data: UIPreferencesNs.UIPreferences) =>
    account.post<UIPreferencesNs.UIPreferences, UserNs.Theme>('set-theme', data),
  setOnboarding: () =>
    user.post<void, CommonNs.GenericResponse>('set-onboarding'),
}
